import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../utility";
import Loader from "../../common/Loader";


const AddFundRequest = ({ amount, setAmount }) => {
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [flag, setFlag] = useState(2);

    const [loading, setLoading] = useState(true);

    // const [amount, setAmount] = useState(null);
    const [msg, setMsg] = useState(null);


    useEffect(() => {
        const token = localStorage.getItem("user_token");
        // console.log("token : ", token);
        axios.get(`${API_URL}/user/profile`, { headers: { 'Authorization': `Bearer ${token}` } }).then((res) => {
            console.log("View User res : ", res);
            setUser(res?.data);
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log("View User error : ", err);
        })
    }, [flag])

    return (
        <div className="staff-detail-page edit-profile">
            {loading ? (
                <Loader />
            ) : (
                <>
                    <h1 className="staffRegNumber">Create Top Up</h1>
                    <h6 className="breadCrumbs mt-4 pb-3">
                        <span className="pointer" onClick={() => navigate('/fund-requests')}>Top Up List</span>
                        <span className="greater-than"> &#62; </span>
                        <span className="viewVCardText">Create new quotation</span>
                    </h6>

                    <h3 className="staffdetail-sub-heading mt-4">Bill information</h3>

                    <div className="d-flex pt-2">
                        <div className="divEditLeft d-flex flex-column">
                            <p className="displayBlockText">Company</p>
                            <p className="displayBlockText">Company Address</p>
                            <p className="displayBlockText">Phone</p>
                            <p className="displayBlockText">TAX ID</p>
                            <p className="displayBlockText">Balance</p>
                        </div>
                        <div className="divEditRight d-flex flex-column">
                            <p className="displayBlockText">
                                {user?.billInfo?.company_name ? user?.billInfo?.company_name : "N/A"}
                            </p>
                            <p className="displayBlockText">
                                {user?.billInfo?.company_address ? user?.billInfo?.company_address : "N/A"}
                            </p>
                            <p className="displayBlockText">
                                {user?.billInfo?.company_phone ? user?.billInfo?.company_phone : "N/A"}
                            </p>
                            <p className="displayBlockText">
                                {user?.billInfo?.company_tax_id ? user?.billInfo?.company_tax_id : "N/A"}
                            </p>
                            <p className="displayBlockText">
                                <input onChange={(e) => setAmount(e.target.value)} type="number" placeholder="Enter amount" className="searchBox w-100" />
                                <h6 className="displayBlockText fw-bold">THB</h6>
                                {msg && <p className="text-danger displayBlockText">{msg}</p>}
                            </p>

                        </div>
                    </div>

                    <div className="d-flex mt-4 mb-4">
                        <button className="pointerButton px-5"
                            onClick={() => {
                                if (amount) {
                                    navigate('/fund-requests/add/transfer');
                                } else {
                                    setMsg("Amount is required");
                                }
                            }}>Next</button>
                        <button className="secondaryPointerButton ms-4 px-5" onClick={() => navigate('/fund-requests')}>Cancel</button>
                    </div>
                </>)}
        </div>
    )
}

export default AddFundRequest;